import {
  MEDIA_DIRECTORY_GET_ROOT_SUCCESS,
  MEDIA_DIRECTORY_GET_SUCCESS,
  MEDIA_DIRECTORY_ADD_VIDEO,
} from './type'

export default function (
  state = {
    entity: null,
  },
  action,
) {
  const { payload, type } = action

  switch (type) {
    case MEDIA_DIRECTORY_GET_ROOT_SUCCESS:
      if (payload.entity == null) {
        return {
          ...state,
          entity: null,
        }
      }

      if (state.entity == null) {
        state.entity = {}
      }

      return {
        ...state,
        entity: {
          ...state.entity,
          ...payload.entity,
        },
      }
    case MEDIA_DIRECTORY_GET_SUCCESS:
      if (payload.entity == null) {
        return {
          ...state,
          entity: null,
        }
      }

      if (state.entity == null) {
        state.entity = {}
      }
      return {
        ...state,
        entity: {
          ...state.entity,
          ...payload.entity,
        },
      }
    case MEDIA_DIRECTORY_ADD_VIDEO:
      // Add newly uploaded video to the beginning of results
      if (state.entity && state.entity.results) {
        return {
          ...state,
          entity: {
            ...state.entity,
            results: [payload.videoDetails, ...state.entity.results],
            totalCount: (state.entity.totalCount || 0) + 1,
          },
        }
      }
      return state
    default:
      return state
  }
}
